<template>
  <div :class="`${noticeClass}-notice`">
    <icon :name="`alert-${noticeClass}`" />
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'Notice',
  props: {
    noticeClass: {
      type: String,
      default: 'error'
    },
    text: {
      type: String,
      default: 'error'
    }
  }
};
</script>
